import { Component, Input, OnInit } from '@angular/core';

import { MAXIMUM_3A_CONTRIBUTION } from '@app/app.constants';

@Component({
  selector: 'app-reporting-deposits',
  templateUrl: './reporting-deposits.component.html',
  styleUrls: ['./reporting-deposits.component.scss'],
  standalone: false
})
export class ReportingDepositsComponent implements OnInit {
  @Input() currency: string;
  @Input() contribution: string;
  @Input() totalInvestment: number;
  @Input() language: string;
  @Input() depositThisYear: number;
  possibleYearlyDeposit: number;

  MAXIMUM_3A_CONTRIBUTION = MAXIMUM_3A_CONTRIBUTION;

  ngOnInit(): void {
    this.possibleYearlyDeposit = this.MAXIMUM_3A_CONTRIBUTION[this.getCurrentYear()][this.contribution];
  }

  getCurrentYear(): number {
    return new Date().getFullYear();
  }

  getPossibleDeposit(): number {
    const depositLeft = this.possibleYearlyDeposit - this.depositThisYear;
    return depositLeft > 0 ? depositLeft : 0;
  }
}
